export default __webpack_public_path__ + "pgnv-assets/76e67c910fe5073a3d3f56d216754d3d.png";